import { render, staticRenderFns } from "./SystemConfigList.vue?vue&type=template&id=8fbf5caa"
import script from "./SystemConfigList.vue?vue&type=script&lang=js"
export * from "./SystemConfigList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports